"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssistantDtoServerMessagesItem = void 0;
exports.CreateAssistantDtoServerMessagesItem = {
    ConversationUpdate: "conversation-update",
    EndOfCallReport: "end-of-call-report",
    FunctionCall: "function-call",
    Hang: "hang",
    LanguageChanged: "language-changed",
    LanguageChangeDetected: "language-change-detected",
    ModelOutput: "model-output",
    PhoneCallControl: "phone-call-control",
    SpeechUpdate: "speech-update",
    StatusUpdate: "status-update",
    Transcript: "transcript",
    ToolCalls: "tool-calls",
    TransferDestinationRequest: "transfer-destination-request",
    TransferUpdate: "transfer-update",
    UserInterrupted: "user-interrupted",
    VoiceInput: "voice-input",
};
